export default function AboutData() {
    return {
        title: "About Hospital Insurance*",
        content:
            "Aflac's hospital insurance can help with the expenses not covered by major medical, which can help prevent high deductibles and out-of-pocket expenses from derailing your life plans. Choosing the right combination of benefits can be hard. Let Aflac help make it easier.",
        }
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Hospital/AboutData.js